
import { Vue, Component, Prop, Emit } from 'nuxt-property-decorator';
import { touchSupported } from '@/util/touchSupported';

@Component({
  inheritAttrs: false
})
export default class SiteMapTooltip extends Vue {
  @Prop({ type: String, default: '' })
  tooltipLabel!: string;

  @Prop({ type: String, default: '' })
  buttonClass!: string;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  openOnClick: boolean = false;

  @Emit('click')
  handleClick(): boolean {
    return true;
  }

  get touchSupported(): boolean {
    return touchSupported();
  }

  mounted() {
    if (this.touchSupported) {
      this.openOnClick = true;
    }
  }
}
